/**
 * Delayed work (debounces, like autosave), behind a port so tests drive it
 * with `ManualTimers` instead of waiting on real time.
 */

/** Cancels a pending callback; harmless once it has run. */
export type CancelTimer = () => void;

export interface Timers {
  /** Runs `work` once, `ms` milliseconds from now. */
  after(ms: number, work: () => void): CancelTimer;
}

/** The real timers, backed by `setTimeout`. */
export const systemTimers: Timers = {
  after: (ms, work) => {
    const handle = setTimeout(work, ms);
    return () => {
      clearTimeout(handle);
    };
  },
};
